import { render } from "./ServiceDesk.vue?vue&type=template&id=67928b0d&scoped=true"
import script from "./ServiceDesk.vue?vue&type=script&lang=ts"
export * from "./ServiceDesk.vue?vue&type=script&lang=ts"

import "./ServiceDesk.vue?vue&type=style&index=0&id=67928b0d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67928b0d"

export default script